/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRolePayloadDto
 */
export interface UpdateRolePayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRolePayloadDto
     */
    role: UpdateRolePayloadDtoRoleEnum;
}


/**
 * @export
 */
export const UpdateRolePayloadDtoRoleEnum = {
    Underwriter: 'Underwriter',
    Finance: 'Finance',
    Claims: 'Claims',
    SuperUser: 'Super User'
} as const;
export type UpdateRolePayloadDtoRoleEnum = typeof UpdateRolePayloadDtoRoleEnum[keyof typeof UpdateRolePayloadDtoRoleEnum];


/**
 * Check if a given object implements the UpdateRolePayloadDto interface.
 */
export function instanceOfUpdateRolePayloadDto(value: object): value is UpdateRolePayloadDto {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function UpdateRolePayloadDtoFromJSON(json: any): UpdateRolePayloadDto {
    return UpdateRolePayloadDtoFromJSONTyped(json, false);
}

export function UpdateRolePayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRolePayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
    };
}

export function UpdateRolePayloadDtoToJSON(json: any): UpdateRolePayloadDto {
    return UpdateRolePayloadDtoToJSONTyped(json, false);
}

export function UpdateRolePayloadDtoToJSONTyped(value?: UpdateRolePayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
    };
}

